import React from 'react'

interface StateType {
  hasError: boolean
}
interface PropType {
  children: any
}
class MasterBoundary extends React.Component<PropType, StateType> {
  constructor (props: PropType | Readonly<PropType>) {
    super(props)
    this.state = {
      hasError: false
    }
  }

  static getDerivedStateFromError (error: any): any {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error }
  }

  componentDidCatch (error: any, errorInfo: any): void {
    // eslint-disable-next-line no-console
    console.log(error, errorInfo)
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
  }

  render (): JSX.Element {
    const { hasError } = this.state
    if (hasError) {
      // You can render any custom fallback UI
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              maxWidth: '90%',
              minWidth: '50%',
              alignItems: 'center'
            }}
          >
            <span
              style={{
                maxWidth: '85%',
                minWidth: '60%',
                overflow: 'hidden',
                marginTop: '3em'
              }}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html:
                  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 522"><defs><linearGradient id="a" x1="1" x2="0" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#ff8960"/><stop offset="1" stop-color="#ff62a5"/></linearGradient><style>.a{fill:none;stroke:#d2d8df;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2.921px}.b{fill:#ebecee}</style></defs><path class="a" d="M18.93 239.74v5.457M6.675 242.696l4.459 4.59M1.46 254.915h6.3M6.165 267.351l4.459-4.59M18.93 268.843v-5.457M28.025 265.205l-3.638-3.638M35.301 256.11h-5.457M31.663 243.378l-3.638 3.638M311.777 1.461v3.638M300.864 12.375h3.638M311.777 23.288V19.65M320.872 12.375h-3.638M100.782 154.251v5.457M84.412 170.621h5.457M100.782 185.172v-5.457M115.334 170.621h-5.457"/><g><path class="a" d="M492.312 352.584a7.874 7.874 0 11-7.872 7.874M528.247 456.1a12.415 12.415 0 11-14.052-10.529"/><path class="b" d="M528.342 281.145c4.674-1.458 11.839-7.174 13.5-13.325 1.5 5.437 7.807 11.867 13.5 12.354-6.4 2.267-12.526 9-13.5 14.3-.663-5.399-9.131-12.543-13.5-13.329M48.53 350.158c2.338-.729 5.919-3.587 6.748-6.662.752 2.717 3.9 5.933 6.748 6.177-3.2 1.132-6.262 4.5-6.748 7.147-.33-2.7-4.565-6.27-6.748-6.662"/><path d="M91.915 97.132a6.1 6.1 0 11-6.108-6.106 6.1 6.1 0 016.1 6.106" fill="#d1d8df"/><path class="b" d="M452.391 480.488a10.2 10.2 0 11-10.206-10.205 10.2 10.2 0 0110.2 10.205M640.848 85.881a8.092 8.092 0 11-8.092-8.1 8.093 8.093 0 018.092 8.1"/><path class="a" d="M205.994 463.951a5.1 5.1 0 11-5.1-5.1 5.1 5.1 0 015.1 5.1zM202.961 57.906a6.1 6.1 0 11-6.108-6.106 6.1 6.1 0 016.108 6.106zM358.667 520.466a7.558 7.558 0 114.375-9.753 7.557 7.557 0 01-4.375 9.753z"/></g><path d="M0 144.535h34.887l-18.275 58.146 81.406-82.233H49.007L76.42 0z" transform="translate(251.748 249.731)" fill="url(#a)"/><g><path d="M460.44 213.178a69.148 69.148 0 00-29.527-12 104.393 104.393 0 00-185.955-52.291 67.145 67.145 0 00-87.944 55.391 69.6 69.6 0 0020.309 136.063 45.02 45.02 0 006.021.42h227.577a69.59 69.59 0 0049.519-127.583" fill="#f1f2f7"/><path d="M266.977 173.76a70.343 70.343 0 00-26.463-5.1c-34.986 0-63.337 24.973-63.337 55.772a49.247 49.247 0 00.857 9.136c27.201-38.425 45.943-53.685 88.943-59.808" fill="#e0e2ee"/></g></svg>'
              }}
            />
            <div style={{ marginTop: '3em', fontSize: '3em' }}>Oops!</div>
            <div
              style={{
                marginTop: '1.5em',
                fontSize: '2em',
                marginBottom: '3em',
                textAlign: 'center'
              }}
            >
              Something went wrong. Check your Internet connection and refresh.
            </div>
          </div>
        </div>
      )
    }
    const { children } = this.props
    return children
  }
}

export default MasterBoundary
